import { render, staticRenderFns } from "./DoctorSettingV2.vue?vue&type=template&id=060674cb&scoped=true"
import script from "./DoctorSettingV2.vue?vue&type=script&lang=js"
export * from "./DoctorSettingV2.vue?vue&type=script&lang=js"
import style0 from "./DoctorSettingV2.vue?vue&type=style&index=0&id=060674cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060674cb",
  null
  
)

export default component.exports